<script setup>
import {defineProps, watch} from "vue";
import BlueEnvelope from "../../../../img/blue-envelope.svg";
import debounce from "../../../../debounce";

const {flowState} = defineProps(['visible', 'flowState']);

const sendToHubspot = async () => {
  try {

      await flowState.services.submitData(flowState.userData());

			// Sync with header CFF
			$('.vf-contact-form-flow-financial-model').hide()
			$('#cff-message-top').show();

      flowState.checkLimits();


  } catch (e) {
    console.log(e)
  }
};

if (flowState.getHubspotStatus()) {
  sendToHubspot()
}

watch(
    () => flowState.getHubspotStatus(),
    debounce(() => {
      if (flowState.getHubspotStatus()) {
        sendToHubspot()
      }
    }, 1000)
);

</script>

<template>
  <div v-if="visible">
    <div class="tab">
      <div class="row pb-0 success-submit justify-content-center">
	      <div class="col-12 d-flex justify-content-center align-items-center">
		      <div class="btn btn-light p-3 me-3"><BlueEnvelope/></div>
		      <p class="fw-bold congrats mb-0 text-center text-white">You will receive an email with the model to your inbox shortly </p>
	      </div>
      </div>
    </div>
  </div>
</template>
